import React, { useEffect, useState } from "react";
import { INVALID_URL, LEFT_NAVIGATION_PAGE_URL, PAGE_TYPE, USER_PRIVILEGE } from "../models/navigation.models";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import commonActions, { StorCurrentLocation, SetExportDataFlag, SetBallotDetailsFromData, setBallotTrackingList } from "../common.actions";
import { cacheManager, checkUserPermissionOnPage, decrypt, encrypt, removeLeadingZeroes } from "../helpers/util-common";
import "../pages/Ballot/_ballotScreen.scss";
import "../pages/WorkItems/_workItemTableScreen.scss";
import AddBallotHeaderModal from "../pages/ballots/addBallotHeader";
import AddAdminWorkitemModal from "../pages/WorkItems/addAdminWorkitem";
import { getBallotTypesAction, getBallotDocumentsListAction } from "../redux/action/ballots";
import { BallotDetailBreadCrumbProps } from "../pages/ballots/interface";
import { getPageId } from "../models/common.models";
import { setNavigationStateAction, SetWIExportDataFlag } from "../workitem.actions";
import paths from "../../breadcrumb-path";
import { PAGE_ID } from "../../common.enum";

function Breadcrumb() {
  const dispatch = useDispatch();
  const showPlaceHolder = false;
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pathSegments = window.location.pathname.split("/");
  const workItemCategory = pathSegments.length >= 4 && pathSegments?.[3];  
  const workItemNumber = pathSegments.filter(segment => segment !== "").pop();  
  const props = useSelector((state: any) => {
    return {
      showCreateBallotFolder: state.commonReducer.showCreateBallotFolderModel,
      userPermission: state.commonReducer.userPermission,
      ballotFlag: state.commonReducer.ballotFlag,
      ballotDetailTag: state.commonReducer.ballotDetailTag,
      permissionData :state.commonReducer.permissionData,
      loading:state.commonReducer.loading,
      miniLoader:state.commonReducer.miniLoader
    };
  });
  const [showAddBallotHeaderModal, setshowAddBallotHeaderModal] = useState(false);
  const [showAddAdminWorkitemModal, setshowAddAdminWorkitemModal] = useState(false);
  const [ballotTypesData, setballotTypesData] = useState<Array<any>>([]);
  const [userEmail, setuserEmail] = useState<string>();
  const [userId, setUserId] = useState<string>("");
  const [BallotId, setBallotId] = useState<number>();
  const [ballotDetailsData, setBallotDetailsData] = useState<BallotDetailBreadCrumbProps>();
  const pathName = `/${window.location.pathname.replace(/\//g, "")}`
  const workItemDetailResponse = useSelector((state: any) => state.commonReducer.workItemDetailData);
  const dtnDetailResponse = useSelector((state: any) => state.commonReducer.dtnDetailData);
  const userPermission = useSelector((state: any) => state.commonReducer.userPermission);
  const workItemListResponse = useSelector((state: any) => state.commonReducer.workItemList);
  const ballotListResponse = useSelector((state: any) => state.commonReducer.ballotListData);
  const storyCurrentLocation = (location: string) => {
    if (window.location.pathname === LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS && location === LEFT_NAVIGATION_PAGE_URL.BALLOTS) {
      clearSelection();
      window.location.href = LEFT_NAVIGATION_PAGE_URL.BALLOTS;
    } else StorCurrentLocation(dispatch, location);
  };

  useEffect(() => {
    const pageId = getPageId(true);
    if (props.ballotDetailTag || pageId === PAGE_ID.BALLOT_ITEM_DETAIL_RESULT || pageId === PAGE_ID.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE) {
      setBallotId(props.ballotDetailTag);
    } else if (props.ballotDetailTag == 0) {
      resetBallotDetailsData();
    }
  }, [props.ballotDetailTag]);

  useEffect(() => {
    if (window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS) !== -1 || window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT) !== -1 || window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE) !== -1 || window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS)!== -1) {
      let currentPath = window.location.pathname;
      const ballotcode = currentPath.substring(currentPath.lastIndexOf("/") + 1);
      let ballotId = decrypt(`${ballotcode}`);
      setBallotId(ballotId);
      if (ballotId === undefined) navigate(`${INVALID_URL.PAGE_NOT_FOUND}`); 
    }
    return () => {};
  }, []);

  useEffect(() => {
    const pageId = getPageId(true);
    if (BallotId && BallotId > 0 && [9, 10, PAGE_ID.BALLOT_ITEM_DETAIL_RESULT, PAGE_ID.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE].includes(pageId)) {
      loadBallotData(BallotId);
    } else resetBallotDetailsData();
  }, [BallotId,location.pathname]);

  const clearSelection = () => {
    props.ballotDetailTag = 0;
    setBallotId(0);
    resetBallotDetailsData();
    SetBallotDetailsFromData(dispatch, {});
  };

  const goBack = () => { navigate(-1); };

  const resetBallotDetailsData = () => {
    const pageId = getPageId(true);
    ![9,10].includes(pageId) && setBallotId(0);
    setBallotDetailsData((prev) => ({
      ...prev,
      BallotId: 0,
      BallotDesignation: "",
      BallotStatus: null,
      BallotType: null,
    }));
  };

  const onClickNavigatePreviousPage = (location: string) => {
    clearSelection();
    navigate(location);
  };

  const loadBallotData = (ballotId: number) => {
    if (ballotId == undefined || ballotId == null || ballotId == 0) return;
    const data = {
      pageNumber: 1,
      pageSize: 10,
      sortColumnWithOrder: { Committee: 1 },
      BallotId: ballotId,
    };
    getBallotDocumentsListAction(dispatch, data, (response: any) => {
      if (response && response?.Data?.length > 0) {
        const ballot = response.Data[0];
        setBallotDetailsData((prev) => ({
          ...prev,
          BallotId: ballot.BallotId,
          BallotDesignation: ballot.BallotDesignation,
          BallotStatus: ballot.BallotStatus,
          BallotType: ballot.BallotType,
          ItemNo: ballot?.ItemNo
        }));
        SetBallotDetailsFromData(dispatch, ballot);
      }
    });
  };

  const addConditionBreadcrumb = (): any => {
    let currentPath = pathName
    window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS) !== -1
      ? (currentPath = LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS)
      : window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL) !== -1
      ? (currentPath = LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL)
      : window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.DTNDETAIL) !== -1
      ? (currentPath = LEFT_NAVIGATION_PAGE_URL.DTNDETAIL)
      : window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS) !== -1
      ? (currentPath = LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS)
      : window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT) !== -1
      ? (currentPath = LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT)
      : window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE) !== -1
      ? (currentPath = LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE)
      : currentPath;

    if (paths[currentPath]) {
      const { parent, page } = paths[currentPath];
      return (<>
        {parent?.map(details => {
          return <li key={details.route} className="breadcrumb-item" aria-label="breadcrumb">
              <Link target="_self" to={details.route} onClick={() => storyCurrentLocation(details.route)}>
                {details.label}
              </Link>
            </li>
          })}
          <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
            {page.label}
          </li>
      </>)
    }
    switch (currentPath) {
      case LEFT_NAVIGATION_PAGE_URL.DASHBOARD:
        return (
          <>
            <li className="breadcrumb-item" aria-label="breadcrumb">
              <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                Dashboard
              </Link>
            </li>
          </>
        );

      case LEFT_NAVIGATION_PAGE_URL.BALLOTS:
        return (
          <>
            {(
              <>
                <li className="breadcrumb-item" aria-label="breadcrumb">
                  <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                  Ballots
                </li>
              </>
            )}
          </>
        );  
      case LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS:
        return (
          <>
            {(
              <>
                <li className="breadcrumb-item" aria-label="breadcrumb">
                  <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                  <a
                    style={{ cursor: "pointer" }}
                    target="_self"
                    onClick={() => {
                      storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.BALLOTS);
                      setBallotTrackingList([]);
                      navigate(LEFT_NAVIGATION_PAGE_URL.BALLOTS);
                      setTimeout(() => {
                        window.location.href = LEFT_NAVIGATION_PAGE_URL.BALLOTS;
                      }, 0);
                      clearSelection();
                  }}>
                    Ballots
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                  {ballotDetailsData && "" + ballotDetailsData.BallotDesignation}
                </li>
              </>
            )}
          </>
        );
      case LEFT_NAVIGATION_PAGE_URL.WORKITEM:
          return (
            <>
              {(
                <>
                  <li className="breadcrumb-item" aria-label="breadcrumb">
                    <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                    Work Items
                  </li>
                </>
              )}
            </>
          );
      case LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL:
          return (
            <>
              {(
                <>
                  <li className="breadcrumb-item" aria-label="breadcrumb">
                    <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                    <Link target="_self" to={LEFT_NAVIGATION_PAGE_URL.WORKITEM} onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.WORKITEM)}>
                      Work Items
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                    {removeLeadingZeroes(`${workItemCategory && workItemCategory}${workItemNumber}`)}
                  </li>
                </>
              )}
            </>
          );
          case LEFT_NAVIGATION_PAGE_URL.DTNDETAIL:
            return (
              <>
                {(
                  <>
                    <li className="breadcrumb-item" aria-label="breadcrumb">
                      <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                        Dashboard
                      </Link>
                    </li>
                    <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                      <Link target="_self" to={`${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${dtnDetailResponse?.WorkItemTrackingNumber && encrypt(((dtnDetailResponse?.WorkItemTrackingNumber?.split("-", 2))[0])?.replace(`${workItemCategory && workItemCategory}`,''))}`} onClick={() => navigate(`${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${encrypt(((dtnDetailResponse?.WorkItemTrackingNumber?.split("-", 2))[0])?.replace(`${workItemCategory && workItemCategory}`,''))}`)}>
                        Draft Tracking Numbers
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                    {`DTN ${(workItemNumber?.split("/", 2))[1]}`}
                    </li>
                  </>
                )}
              </>
            );  
            case LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG:
              return (
                <>
                  {(
                    <>
                      <li className="breadcrumb-item" aria-label="breadcrumb">
                        <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                        <Link target="_self" to={LEFT_NAVIGATION_PAGE_URL.WORKITEM} onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.WORKITEM)}>
                          Work Items
                        </Link>
                      </li>
                      <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                        Audit Log
                      </li>
                    </>
                  )}
                </>
              );
              case LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS:
                return (
                  <>
                    {(
                      <>
                        {ballotDetailsData?.BallotDesignation ? 
                        <>
                          <li className="breadcrumb-item" aria-label="breadcrumb">
                            <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                              Dashboard
                            </Link>
                          </li>
                          <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                            <Link target="_self" to={LEFT_NAVIGATION_PAGE_URL.BALLOTS} onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.BALLOTS)}>
                              Ballots
                            </Link>
                          </li>
                          <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                            <Link
                              target="_self"
                              to={LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS+`/${encrypt(ballotDetailsData?.BallotId)}`}
                              onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS+`/${encrypt(ballotDetailsData?.BallotId)}`)}
                            >
                              {ballotDetailsData && "" + ballotDetailsData.BallotDesignation}
                            </Link>
                          </li>
                          <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                              Ballot Queue
                          </li>
                        </> : null}
                      </>
                    )}
                  </>
                );
            case LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT:
              return (
                <>
                  {(
                    <>
                      <li className="breadcrumb-item" aria-label="breadcrumb">
                        <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                        <a
                          style={{ cursor: "pointer" }}
                          target="_self"
                          onClick={() => {
                            navigate(LEFT_NAVIGATION_PAGE_URL.BALLOTS)
                          }}
                        >
                          Ballots
                        </a>
                      </li>
                      <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                        <a
                          style={{ cursor: "pointer" }}
                          target="_self"
                          onClick={() => {
                            navigate(
                              `${LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS}/${encrypt(
                                ballotDetailsData?.BallotId
                              )}`
                            );
                          }}
                        >
                          {ballotDetailsData && "" + ballotDetailsData.BallotDesignation}
                        </a>
                      </li>
                      <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                        Item {window.location.pathname.split('/')[2]}
                      </li>
                    </>
                  )}
                </>
            );
            case LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE:
              return (
                <>
                  {(
                    <>
                      <li className="breadcrumb-item" aria-label="breadcrumb">
                        <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                        <a
                          style={{ cursor: "pointer" }}
                          target="_self"
                          onClick={() => {
                            navigate(LEFT_NAVIGATION_PAGE_URL.BALLOTS)
                          }}
                        >
                          Ballots
                        </a>
                      </li>
                      <li className="breadcrumb-item" aria-label="breadcrumb" aria-current="page">
                        <a
                          style={{ cursor: "pointer" }}
                          target="_self"
                          onClick={() => {
                            navigate(
                              `${LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS}/${encrypt(
                                ballotDetailsData?.BallotId
                              )}`
                            );
                          }}
                        >
                          {ballotDetailsData && "" + ballotDetailsData.BallotDesignation}
                        </a>
                      </li>
                      <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                        <a
                          style={{ cursor: "pointer" }}
                          target="_self"
                          onClick={() => {
                            navigate(
                              `${LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT}/${window.location.pathname.split('/')[2]}/${encrypt(
                                ballotDetailsData?.BallotId
                              )}`
                            );
                          }}
                        >
                          Item {window.location.pathname.split('/')[2]}
                        </a>
                      </li>
                      <li className="breadcrumb-item active" aria-label="breadcrumb" aria-current="page">
                        Ruling Rationale
                      </li>
                    </>
                  )}
                </>
              );
        default:
        return (
          <>
            <li className="breadcrumb-item" aria-label="breadcrumb">
              <Link target="_self" to="#" onClick={() => storyCurrentLocation(LEFT_NAVIGATION_PAGE_URL.DASHBOARD)}>
                Dashboard
              </Link>
            </li>
          </>
        );
    }
  };

  const handleExport = async () => {
    SetExportDataFlag(dispatch, true);
  };

  const handleWIExport = async () => {
    SetWIExportDataFlag(dispatch, true);
  };

  const handleShowAddBallotModal = async () => {
    const userDetail = cacheManager.getItem("userDetail") && JSON.parse(cacheManager.getItem("userDetail"));
    setuserEmail(userDetail.email);
    setUserId(userDetail.userId);
    dispatch(commonActions.setOverlayLoader(true));
    let ballotTypes;
    getBallotTypesAction(dispatch, (response: any) => {
      dispatch(commonActions.setOverlayLoader(false));
      if (response && response.length > 0) {
        ballotTypes = response;
        setballotTypesData(ballotTypes);
        setshowAddBallotHeaderModal(true);
      }
    });
  };

  const handleShowAddAdminWorkitemModal = async () => {
    const userDetail = cacheManager.getItem("userDetail") && JSON.parse(cacheManager.getItem("userDetail"));
    setuserEmail(userDetail.email);
    setshowAddAdminWorkitemModal(true);
  };

  const handleCloseAddBallotModal = () => {
    setshowAddBallotHeaderModal(false);
  };
  
  const handleCloseAddAdminWorkitemModal = () => {
    setshowAddAdminWorkitemModal(false);
  };

  const handleAddBallotItem = () => {};
  const handleGeneratePreview = () => {};
  const handlePreviewAndPublish = () => {};
  
  return (   
    <div className="breadcrumb-wrapper">
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb astm-breadcrumb">
            {" "}
            {
              addConditionBreadcrumb()
            }
          </ol>
        </nav>

        {window.location.pathname == LEFT_NAVIGATION_PAGE_URL.DASHBOARD ? (
          <div className="sub-title-wrap">
            <h1 className="astm-type-heading--h3">Dashboard</h1>
          </div>
        ) : (
          <>
            {(pathName === "/ballot" || location.pathname.indexOf("/ballotDetail/") !== -1) ? (
              <div className="sub-title-wrap">
                {window.location.pathname.indexOf("/ballotDetail") === -1 ? (
                checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW)  &&  <h1 className="astm-type-heading--h1">Ballots</h1>
                ) : null}
                <div>
                  {pathName === "/ballot" ? (
                    <>
                      <div className="flex-gap-8">
                      { checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.ADD )&& 
                        <button type="button" className="btn btn-primary astm-btn" id="addBallotHeader" data-testid="Addnewballot" onClick={handleShowAddBallotModal}>
                          <i className="far fa-solid fa-plus mr8"></i>
                          <span> Add new ballot </span>
                        </button>
                      }{checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW) && 
                        <button type="button" className="btn btn-secondary export-button astm-btn" id="exportDocument" data-testid="exportSheet" disabled={props.loading || props.miniLoader || ballotListResponse?.Data?.length === 0}
                          onClick={(props.loading || props.miniLoader || ballotListResponse?.Data?.length === 0)
                            ? undefined
                            : handleExport}>
                          <div className="export-text">
                            <div>
                              <i className="far fa-file-excel"></i>
                              <span> Export to excel </span>
                            </div>
                          </div>
                        </button>
                      }
                      </div>
                    </>
                  ) : (
                    <>
                      {showPlaceHolder && (
                        <div>
                          <button type="button" className="btn btn-primary export-button" id="addBallotItemsBtn" data-testid="exportSheet" onClick={handleAddBallotItem}>
                            <i className="far fa-solid fa-plus mr8"></i>
                            <span> Add ballot items </span>
                          </button>
                          <button type="button" className="btn btn-primary export-button" id="generatePreviewBtn" data-testid="exportSheet" onClick={handleGeneratePreview}>
                            <div className="export-text">
                              <span> Generate Preview </span>
                            </div>
                          </button>
                          <button type="button" className="mr16 btn btn-primary mr16 waring-button astm-btn" id="previewPublishBtn" data-testid="exportSheet" onClick={handlePreviewAndPublish}>
                            <span> Preview and Publish </span>
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) 
            : (pathName === "/workitem" || window.location.pathname.indexOf("/workItemDetail") !== -1) 
            ? (pathName === "/workitem"
              ? (
              <div className="sub-title-wrap"><div>{checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW) &&<h1 className="astm-type-heading--h1">Work Items</h1>}</div>
                <div className="flex-gap-8">
                  {checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.ADD) && <button type="button" className="btn btn-primary waring-button astm-btn add-admin-workitem-button" id="addAdminWorkitem"
                    data-testid="AddAdminWorkitem" onClick={handleShowAddAdminWorkitemModal}>
                    <i className="far fa-solid fa-plus mr8"></i>
                    <span> Create admin work item </span>
                  </button>}
                  {checkUserPermissionOnPage(userPermission,PAGE_TYPE.BT_BALLOT_QUEUE,USER_PRIVILEGE.VIEW) ? 
                  <button type="button" className="btn btn-secondary astm-btn" style={{display: "inline"}}
                    onClick={()=> location.href = LEFT_NAVIGATION_PAGE_URL.GLOBALBALLOTQUEUE}>
                    <span> View Ballot Queue </span>
                  </button> : null}
                  {checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW) && <button
                    type="button"
                    className="btn btn-secondary export-button astm-btn"
                    id="exportDocument"
                    data-testid="exportSheet"
                    disabled={props.loading || props.miniLoader || workItemListResponse?.Data?.length === 0}
                    onClick={
                      (props.loading || props.miniLoader || workItemListResponse?.Data?.length === 0)
                        ? undefined
                        : handleWIExport
                    }
                  >
                    <div className="export-text">
                      <div>
                        <i className="far fa-file-excel"></i>
                          <span> Export to excel </span>
                      </div>
                    </div>
                  </button>}
                  {(checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW)|| checkUserPermissionOnPage(userPermission,PAGE_TYPE.WITN,USER_PRIVILEGE.VIEW)) &&  <button type="button" className="btn btn-secondary export-button astm-btn auditlog-button" id="workItemAuditLog" data-testid="workItemAuditLog"
                    onClick={()=> {
                      dispatch(commonActions.setminiLoader(false));   
                      navigate(LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG);
                    }}>
                    <span> Audit log </span>
                  </button>}
                </div>
              </div>
              ) 
              : null
             ) 
             : null
          }
          </>
        )}
        {window.location.pathname.indexOf(LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG) !== -1 && pathName === LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG && checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW) &&
        <>
           <div className="workItem-details">
            <div className="workItem-details-header-left">
              <button type="button" className="btn astm-btn btn-light back-btn" data-testid="backButtonOnBallotSequencePage" onClick={(event) => {
                  setNavigationStateAction(dispatch, true);
                  onClickNavigatePreviousPage(LEFT_NAVIGATION_PAGE_URL.WORKITEM);
                }}>
                <i className="astm-icon far fa-arrow-circle-left mr-2" />
                Back
              </button>
              <div className="heading"><h1 className="astm-type-heading--h1 mr16"> Audit Log </h1></div>
            </div></div>
            <hr/>
          </>}
      </div>
      {showAddBallotHeaderModal && <AddBallotHeaderModal showAddBallotHeaderModal={true} userId={userId} ballotTypes={ballotTypesData} closeAddBallotHeaderModal={handleCloseAddBallotModal} userEmail={userEmail} />}
      {showAddAdminWorkitemModal && <AddAdminWorkitemModal showAddAdminWorkitemModal={true}  closeAddAdminWorkitemModal={handleCloseAddAdminWorkitemModal} userEmail={userEmail} />}
    </div>
  );
}

export default Breadcrumb;
